export const uk = {
    'build-date': 'Дата составления отчёта',
    download: 'Скачать отчёт',
    'end-date': 'Дата окончания',
    id: 'ID',
    link: 'Скачать отчёт',
    'start-date': 'Дата начала',
    status: 'Статус'
};
